export * from './richtext'
export * from '../hooks/useDitherBackground'
export * from './footnotes'
export * from './asset-helpers'

type IntroSemanticHeadingFields = {
  hasLogoHeading: boolean
  hasIntroContextHeading: boolean
}

export function hasIntroSemanticHeading({hasLogoHeading, hasIntroContextHeading}: IntroSemanticHeadingFields): boolean {
  return hasLogoHeading || hasIntroContextHeading
}
